import React, {useEffect, useState} from "react";
import { useTranslation } from "react-i18next";
import CustomTooltip from "../../CustomTooltip";
import {DeleteIcon, LoadingIcon} from "../../../assets/icons/Icons";
import {Link} from "react-router-dom";
import MessageError from "../../MessageError";
import {ValidateCardRange} from "../../../api/batch-order/validateCardRange";
import { getCardByPrn } from "../../../api/sell-orders/getCardByPrn";

const CardRow = ({ rowIndex, rowData, onFieldChange, removeRow , ...props}) => {

    const [buttonDisabled, setButtonDisabled] = useState(true);
    const [validationLoading, setValidationLoading] = useState(false);
    const [error, setError] = useState('');
    const [previousRowData, setPreviousRowData] = useState(rowData);

    const handleValidate = async () => {
        setError('');
        setValidationLoading(true);
        try {
            const [response, cardRes] = await Promise.all([
                ValidateCardRange({office_id: props.formData.office_id, start_processor_reference: rowData.start_processor_reference, end_processor_reference: rowData.end_processor_reference}),
                getCardByPrn({ prn: rowData.start_processor_reference }),
            ]);
            props.setFormData && props.setFormData(prevData => ({
                ...prevData,
                program_id: cardRes?.data?.accounts?.[0].program_id ?? null,
            }))            
            if(response?.error?.message){
                setError(response.error.message);
            } else {
                props.setFormData(prevData => ({
                    ...prevData,
                    quantity: response.quantity
                }));
                setError('');
                onFieldChange("card_type", "Oxford Gift Card PLUS");
            }
        } catch (err){
            console.log("Error fetching data: " + err);
        }
        setValidationLoading(false);
    };

    const { t } = useTranslation();

    useEffect(() => {
        if (
            previousRowData.start_processor_reference !== rowData.start_processor_reference ||
            previousRowData.end_processor_reference !== rowData.end_processor_reference
        ) {
            setError('');
            onFieldChange({
                card_type: '',
                load_amount: ''
            });
        }
        setPreviousRowData(rowData);
    }, [rowData]);

    useEffect(() => {

        if(rowData && rowData.start_processor_reference?.length === 12
            && rowData.end_processor_reference?.length === 12
            && props.formData.office_id){
            setButtonDisabled(false);
            if(props.formData.quality > 0){
                setButtonDisabled(true);
                setError(t("Start Proxy Number") + " " + t("can not be larger than") + " " + t("End Proxy Number"));
            } else {
                setButtonDisabled(false);
                setError('');
            }
        } else {
            setButtonDisabled(true);
        }

    }, [rowData, props.formData.office_id]);


    const isFieldVisible = (fieldName) => {
        if(!props.hiddenFields){
            return true;
        } else if (!props.hiddenFields.includes(fieldName)){
            return true;
        } else {
            return false
        }
    }

    return (
        <>
            {isFieldVisible("start_processor_reference") && (
                <td>
                    <input
                        type="number"
                        placeholder={t("Proxy Number")}
                        value={rowData.start_processor_reference || ""}
                        onChange={(e) => {
                            if ( e.target.value >= 0) {
                                onFieldChange("start_processor_reference",  e.target.value);
                            }
                        }}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(e) => { if (e.key === 'ArrowUp' || e.key === 'ArrowDown') e.preventDefault(); }}
                    />
                    {error && <MessageError error={error} />}
                </td>
            )}
            {isFieldVisible("end_processor_reference") && (
                <td>
                    <input
                        type="number"
                        placeholder={t("End Proxy Number")}
                        value={rowData.end_processor_reference || ""}
                        onChange={(e) => {
                            if ( e.target.value >= 0) {
                                onFieldChange("end_processor_reference",  e.target.value);
                            }
                        }}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(e) => { if (e.key === 'ArrowUp' || e.key === 'ArrowDown') e.preventDefault(); }}
                    />
                </td>
            )}
            {isFieldVisible("validate_button") && (
                <td>
                    <button
                        className={`btn btn-primary btn-small ${validationLoading ? 'btn-loading' : ''}`}
                        onClick={handleValidate}
                        disabled={buttonDisabled}
                    >
                        {validationLoading ? <LoadingIcon /> : ''}
                        {t("Validate")}
                    </button>
                </td>
            )}
            {isFieldVisible("card_type") && (
                <td>
                    <input
                        type="text"
                        placeholder={t("Card Type")}
                        value={rowData.card_type || ""}
                        onChange={(e) => onFieldChange("card_type", e.target.value)}
                        disabled
                    />
                </td>
            )}
            {isFieldVisible("load_amount") && (
                <td>
                    <input
                        type="number"
                        placeholder={t("Amount")}
                        value={rowData.load_amount || ""}
                        onChange={(e) => {
                            if ( e.target.value >= 0) {
                                onFieldChange("load_amount",  e.target.value);
                            }
                        }}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(e) => { if (e.key === 'ArrowUp' || e.key === 'ArrowDown') e.preventDefault(); }}
                    />
                </td>
            )}
            {isFieldVisible("remove_button") && (
                <td className="text-center">
                    <Link to="#" onClick={(e) => {
                        e.preventDefault();
                        removeRow(rowIndex);
                    }}>
                        <CustomTooltip icon={<DeleteIcon />} message={t("Remove Row")} />
                    </Link>
                </td>
            )}
        </>
    );
};

export default CardRow;
